export default {
  brand: {
    include_brand_logo: true,
    include_brand_marketing_cover_image: true,
  },
}
